module.exports = __webpack_public_path__ + "static/media/K6.718f2d3f.gif";